import React from 'react'
import styles from 'modules/Agency/agency.module.scss'
import { Button, Grid, Icon, Spinner } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const Pagination = ({ loading, pagination, data, handleChangePage }) => {
  const { t } = useTranslation()

  return (
    pagination.total > data.length && (
      <div className={styles['pagination']}>
        <Grid alignItems={'center'} justifyContent={'center'}>
          <Button
            disabled={loading}
            onClick={handleChangePage}
            variant={'ghost'}
            startIcon={
              loading ? (
                <Spinner width={16} color={'inherit'} />
              ) : (
                <Icon name={'plus'} size={'s'} />
              )
            }
          >
            {t('common::pagination.show_more')}
          </Button>
        </Grid>
      </div>
    )
  )
}

Pagination.propTypes = {
  loading: PropTypes.bool,
  pagination: PropTypes.object,
  data: PropTypes.array,
  handleChangePage: PropTypes.func,
}

export default Pagination
